import React from 'react';

function UploadFile(props: object) {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.8125 21.9375H7.59373C6.75626 21.9365 5.92859 21.7573 5.16564 21.412C4.40268 21.0667 3.72188 20.5631 3.16842 19.9346C2.61496 19.3061 2.20148 18.567 1.95543 17.7665C1.70938 16.966 1.63638 16.1223 1.74128 15.2915C1.84617 14.4606 2.12656 13.6615 2.56384 12.9473C3.00113 12.2331 3.5853 11.62 4.2776 11.1488C4.96991 10.6775 5.75451 10.3589 6.57935 10.214C7.40419 10.0692 8.25041 10.1014 9.06185 10.3085"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6562 16.875L16.0312 13.5L19.4062 16.875"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0312 21.9375V13.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4375 13.5019C8.43786 11.9808 8.84941 10.4881 9.62862 9.18171C10.4078 7.87534 11.5257 6.8039 12.8639 6.08078C14.2022 5.35767 15.711 5.00977 17.2308 5.07391C18.7505 5.13805 20.2247 5.61183 21.4972 6.44513C22.7698 7.27843 23.7934 8.44024 24.4598 9.80762C25.1261 11.175 25.4105 12.6971 25.2827 14.2128C25.1549 15.7286 24.6197 17.1816 23.7338 18.4181C22.8478 19.6546 21.6441 20.6286 20.25 21.237"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UploadFile;
